import React from 'react'
import {HTMLTable} from '@blueprintjs/core'
import ServiceRegistry from 'core/util/ServiceRegistry';
import ILocalCacheService from 'core/service/cache/ILocalCacheService';

const DiscountDetails =props =>{
    const payment=ServiceRegistry.get(ILocalCacheService).getString("paymentType");
    if(!props.priceDetails || props.priceDetails.length ==0) return<div>No Bulk Discount</div>
    return (
        <div >
              <div>Save money when you purchase this item in bulk!</div>
              <br/>
              <HTMLTable  >
                <tbody>
                  {props.priceDetails.map((item) => 
                     <tr>{item.min} - {item.max} <td/> <td/>{`${payment === "entryvar.currency" ?'$':''}`} {item.cost} / Seat</tr> )}
                </tbody> 
              </HTMLTable>
        </div>
    );
};

export default DiscountDetails


// WEBPACK FOOTER //
// ./src/panels/bundleEntries/component/DiscountDetails.tsx